export default function NotFound() {
  return (
    <div>
      <h3>Not found</h3>
    </div>
  );
}
